import { Box, Text } from '@chakra-ui/react';

export const FormSection = ({ title, children }) => (
  <Box>
    <Text fontSize='lg' fontWeight='semibold' mb={4}>
      {title}
    </Text>
    {children}
  </Box>
);
